import {
    DESTINATION_LOAD_DATA,
    DESTINATION_LOAD_EVENTS,
    DESTINATION_UPDATE,
    DESTINATION_RESET,
    DESTINATION_GET_AIRPORT_STRUCTURED_DATA,
} from './destination-actions';
import {ROUTER_DATA_LOAD_FULFILLED} from 'router/router-actions';

export const initialState = () => ({
    isPending: false,
    data: {},
    airportStructuredData: [],
    // {
    //     relative_url,
    //     monthly_relative_url,
    //     generic_destination,
    //     monthly_enabled,
    //     desktop_zoom_level,
    //     monthly_destination_info_title,
    //     kml_map_layer_url,
    //     destination_info_title,
    //     timezone,
    //     id,
    //     meta_description,
    //     city,
    //     title,
    //     spothero_city,
    //     zipcode,
    //     state,
    //     kml_map_layer_id,
    //     parent_url,
    //     monthly_meta_title,
    //     venue_content,
    //     venue_content_enabled,
    //     meta_title,
    //     description,
    //     monthly_description,
    //     kml_map_layer_enabled,
    //     monthly_meta_description,
    //     short_description,
    //     categories,
    //     latitude,
    //     longitude,
    //     override_ideal_zoom,
    //     deep_links,
    //     mobile_zoom_level,
    //     monthly_desktop_zoom_level,
    //     monthly_mobile_zoom_level,
    //     street_address,
    //     google_places: [{
    //         google_places_id,
    //         google_places_name,
    //         google_places_place_id,
    //         pk
    //     }],
    //     has_upcoming_events,
    //     events, -> only on here if page is loaded with has_upcoming_events enabled or search params endpoint after a search has_upcoming_events is true
    //     airport
    // }
    error: null
});

export default function destination(state = initialState(), {type, payload}) {
    switch (type) {
        case `${DESTINATION_LOAD_DATA}_PENDING`: {
            return {
                ...state,
                isPending: true,
                error: null
            };
        }

        case `${DESTINATION_LOAD_DATA}_FULFILLED`: {
            return {
                ...state,
                isPending: false,
                data: {
                    ...state.data,
                    ...payload.data.data
                }
            };
        }

        case `${DESTINATION_LOAD_DATA}_REJECTED`: {
            return {
                ...state,
                error: 'Could not load destination data.'
            };
        }

        case `${DESTINATION_LOAD_EVENTS}_PENDING`: {
            return {
                ...state,
                isPending: true,
                error: null
            };
        }

        case `${DESTINATION_LOAD_EVENTS}_FULFILLED`: {
            return {
                ...state,
                isPending: false,
                data: {
                    ...state.data,
                    events: payload.data.data.results
                }
            };
        }

        case `${DESTINATION_LOAD_EVENTS}_REJECTED`: {
            return {
                ...state,
                error: 'Could not load events.'
            };
        }

        case DESTINATION_UPDATE: {
            return {
                ...state,
                data: {
                    ...state.data,
                    ...payload
                }
            };
        }

        case DESTINATION_RESET: {
            return initialState();
        }

        case ROUTER_DATA_LOAD_FULFILLED: {
            const {
                destination: cleanedDestinationState
            } = payload;

            if (cleanedDestinationState) {
                return cleanedDestinationState;
            } else {
                return state;
            }
        }

        case `${DESTINATION_GET_AIRPORT_STRUCTURED_DATA}_FULFILLED`: {
            // strip out all unnecessary data
            const responseData = payload.data.data.results;
            const airportStructuredData = responseData.reduce((firstSixReviewedSpots, spotData) => {
                if (firstSixReviewedSpots.length < 6 && spotData.rating_info.number_of_ratings > 9) {
                    const {
                        id,
                        logos,
                        title,
                        airport: {
                            lowest_daily_rate: lowestDailyRate
                        },
                        street_address, // eslint-disable-line camelcase
                        city,
                        state: spotState,
                        zipcode,
                        rating_info // eslint-disable-line camelcase
                    } = spotData;

                    firstSixReviewedSpots.push({
                        facility: {
                            id,
                            logos,
                            title,
                            lowestDailyRate,
                            street_address, // eslint-disable-line camelcase
                            city,
                            state: spotState,
                            zipcode,
                            rating_info // eslint-disable-line camelcase
                        }
                    });
                }

                return firstSixReviewedSpots;
            }, []);

            return {
                ...state,
                airportStructuredData
            };
        }

        default:
            return state;
    }
}
